import { Navigate, useParams } from 'react-router-dom';

// 영수증 QR이 가리키는 짧은 주소 /d/<배송묶음 UUID>.
// 주소를 짧게 유지해야 QR 밀도가 낮아져 감열 인쇄물에서도 잘 읽힌다.
// (/delivery?delivery_id=... 형태보다 19자 짧아 QR이 한 버전 작아진다)
//
// 실제 화면은 기존 배송 목록 하나만 유지하고, 여기서는 목적지 주소로 바꿔주기만 한다.
export default function DeliveryQrRedirect() {
  const { deliveryId } = useParams();

  if (!deliveryId) {
    return <Navigate to="/delivery" replace />;
  }

  // replace를 쓰면 뒤로가기 시 이 리다이렉트 경로로 되돌아오지 않는다
  return <Navigate to={`/delivery?delivery_id=${encodeURIComponent(deliveryId)}`} replace />;
}
